import { post } from './axios';
import {
  IPostApiAuthorizedRefreshTokenResponse,
  IPostApiAuthorizedRefreshTokenV2Request,
  IPostApiAuthorizedRefreshTokenV2Response,
} from './interface/authorized';

export const refreshTokenV2 = (
  params: IPostApiAuthorizedRefreshTokenV2Request,
) => {
  return post<
    IPostApiAuthorizedRefreshTokenV2Response,
    IPostApiAuthorizedRefreshTokenV2Response
  >('/api/authorized/refresh_token_V2', params);
};

export const refreshToken = () => {
  return post<
    IPostApiAuthorizedRefreshTokenResponse,
    IPostApiAuthorizedRefreshTokenResponse
  >('/api/authorized/refresh_token');
};
